import _get from 'lodash/get';
import { useNavigation } from '@/processes/Router';
import DashboardAccounting from './accounting/Dashboard';
import DashboardAccountingAndAnonymous from './accountingAndAnonymous/Dashboard';
// import DashboardShared from './shared/Dashboard';

const DASHBOARDS = {
  BTC: DashboardAccountingAndAnonymous,
  KAS: DashboardAccounting,
  DNX: DashboardAccounting,
  GRAM: DashboardAccounting,
  RVN: DashboardAccountingAndAnonymous,
  LTCBTC: DashboardAccountingAndAnonymous,
  ETC: DashboardAccountingAndAnonymous,
}

const Dashboard = () => {
  const { coin } = useNavigation();
  const DashboardPage = _get(DASHBOARDS, coin);
  return <DashboardPage/>;
}

export default Dashboard;
